import LogoVertical from '@/assets/icons/logo-vertical.svg?react'
import { routes } from '@/pages'
import { Link } from 'react-router-dom'

export const Header = () => {
  return (
    <header className="absolute top-0 z-[1] w-full justify-between px-12 py-6 text-right max-tablet:px-5">
      <Link to={routes.dashboard.path} className="absolute left-1/2 -translate-x-1/2">
        <LogoVertical />
      </Link>
    </header>
  )
}
